interface ButtonrPops {
  onConfirm: () => void;
  backgroundColor?: string;
  boxShadowColor?: string;
  message?: string;
  height?: number;
  style?: Record<string, any>;
}

export default function AppButton({onConfirm, height = 46, backgroundColor = '#14A1C8', boxShadowColor = '#0F7996', message = '확인', style  }: ButtonrPops) {
  return (
    <button
        onClick={onConfirm}
        className="w-full py-4 text-white font-bold rounded-xl transition-colors"
        style={{ height: height, backgroundColor: backgroundColor, boxShadow: `0px 3.5px 0px 0px ${boxShadowColor}`, ...style }}
      >
    {message}
    </button>
  );
}

      